import { useMutation } from "@tanstack/react-query";
// Raw axios (NOT axiosInstance) is intentional here: `url` is a presigned S3
// URL that embeds its own authentication signature in the query string.
// Adding an Authorization header would cause S3 to reject the request with a
// SignatureDoesNotMatch error. This is the one approved exception to the
// "always use axiosInstance" rule documented in CLAUDE.md.
import axios from "axios";

interface UpdateDocumentTextPayload {
  url: string;
  text: string;
}

const updateDocumentText = async (payload: UpdateDocumentTextPayload) => {
  const { url, text } = payload;
  await axios.put(url, text, {
    headers: {
      "Content-Type": "text/plain",
    },
  });
};

export const useUpdateDocumentText = () => {
  return useMutation({
    mutationFn: updateDocumentText,
  });
};
